import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpUtils } from '../utils/http-utils';
import {SummedMasterReport} from '../../kitchen/shared/domain/report/summed-master-report.model';

@Injectable()
export class AdStatsOptimizationsService {

  constructor(private http: HttpClient) {
  }

  datadogGraph(unitId: string): Observable<DataDogResponse> {
    return this.http.get<DataDogResponse>(`${environment.serviceUrl}/ad-stats/optimizations/datadog-graph`, {
      params: HttpUtils.getHttpParams({
        unitId
      })
    });
  }

  adUnitDailyReport(params: {unitId: string, dateFrom: string, dateTo: string}): Observable<SummedMasterReport[]> {
    return this.http.get<SummedMasterReport[]>(`${environment.serviceUrl}/ad-stats/optimizations/unit-report`, {
      params: HttpUtils.getHttpParams(params)
    });
  }

}


export class DataDogResponse {
  embed_id: string;
  template_variables: string[];
  html: string;
  graph_title: string[];
  dash_url: string[];
  dash_name: string[];
}

